import { getRandomId } from '../../Utils/baseComponentHelper.js';
import '../../../utils/log.js';
import '../../Utils/numeriHelper.js';
import 'react/jsx-runtime';
import 'react';
import 'react-dom/client';
import '../../ModalContext/ModalContext.js';
import '../../../utils/webClient.js';
import '../../../utils/document.js';
import '../../../utils/Switch.js';
import './useViewport.js';

/**
 * Crea un id univoco per il componente
 * @returns component id
 */
function useComponentId() {
    return getRandomId();
}

export { useComponentId as default };
